import { render } from "./MentorProfilePage.vue?vue&type=template&id=c3dcfc28&scoped=true"
import script from "./MentorProfilePage.vue?vue&type=script&lang=js"
export * from "./MentorProfilePage.vue?vue&type=script&lang=js"

import "./MentorProfilePage.vue?vue&type=style&index=0&id=c3dcfc28&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3dcfc28"]])

export default __exports__